import { z } from 'zod/v4'
import { PlatformShortcode } from '@/utils/convert-platform'

const collaborativeItemTypeSchema = z.enum([
  'post',
  'reels',
  'live',
  'story',
  'video',
  'shorts',
  'ad_authorization', // 廣告授權
  'material_authorization', // 素材授權
])
export type CollaborativeItemType = z.infer<typeof collaborativeItemTypeSchema>

const basicCollaborativeItemSchema = z.object({
  collaborative_items_count: z.number(),
  cooperation_fee: z.string().transform(Number),
})

const customCollaborativeItemSchema = basicCollaborativeItemSchema.extend({
  platform_name: z.string().min(1),
  is_custom_platform: z.literal(true),
  collaborative_item: z.string().min(1),
  is_custom_collaborative_item: z.literal(true),
})

export const collaborativeItemSchema = z.union([
  z.discriminatedUnion('is_custom_collaborative_item', [
    basicCollaborativeItemSchema.extend({
      platform_name: z.enum(PlatformShortcode),
      is_custom_platform: z.literal(false),
      collaborative_item: collaborativeItemTypeSchema,
      is_custom_collaborative_item: z.literal(false),
    }),
    customCollaborativeItemSchema.extend({
      platform_name: z.enum(PlatformShortcode),
      is_custom_platform: z.literal(false),
    }),
  ]),
  customCollaborativeItemSchema,
])
export type CollaborativeItem = z.infer<typeof collaborativeItemSchema>
